(function () {

  'use strict';

  angular.module('NetworkProperties')

    .constant('NETWORK_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-computer',
        section: 'computers',
        caption: 'Computers',
        selected: false,
        show: true
      },
      {
        icon: 'icon-printer',
        section: 'printers',
        caption: 'Printers',
        selected: false,
        show: true
      }
    ])

    .controller('NetworkPropertiesController', function (
      $rootScope, $scope, $filter, $location, URLS, NetworkListService, toastr,
      $routeParams, URL_PARAMS, TenantListService, WorkstationListService, $ngBootbox,
      SUPPORTED_OS, WorkstationListPaging, SORT_WORKSTATIONS, NETWORK_PROPERTIES_TABS,
      EventHandlerService, SitesProviderService, currentTenant, $timeout, enums,
      EventServiceEvents) {

      $scope.tabs = NETWORK_PROPERTIES_TABS;
      $scope.searchPattern = '';
      $scope.searchInputFieldHolderFocusKey = 'searchInputFieldHolderFocusKey';
      $scope.network = null;
      $scope.networkOriginal = null;
      $scope.networkPropertiesForm = {};
      $scope.supportedOs = SUPPORTED_OS;
      $scope.helpCaption = 'HelpNetworkPropertiesSetup';
      $scope.tenantListService = TenantListService;
      $scope.tenant = currentTenant;
      $scope.me = null;
      $scope.isThisResourceMine = false;

      // Computers **********************************************
      $scope.checkAllCheckboxes = false;
      $scope.lastPageReached = false;
      $scope.filtersList = null;
      $scope.workstationListPaging = new WorkstationListPaging();
      $scope.requestType = 'GET';
      $scope.workstationContainer = null;
      $scope.searchInputPlaceholderText = 'SearchComputerByName';
      $scope.noDataMessage = 'NoComputers';
      $scope.orderWorkstationsByText = 'HostName';
      $scope.reverseWorkstations = false;
      $scope.eventHandlerService = EventHandlerService;

      (function () {
        initEventHandler();
        checkRouteParams();
        getNetwork();
        setListeners();
      })();

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

      function checkRouteParams() {
        if ($routeParams.networkSection) {
          $scope.showSection = $routeParams.networkSection;
        } else {
          $scope.showSection = 'setup';
        }
      }

      $scope.setSection = function (section) {
        $scope.showSection = section;
        const url = $location.path();
        $location.path(url, false).search({ networkSection: section });
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          $scope.isThisResourceMine = isThisResourceMine($scope.networkOriginal);
        }
      });

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        if ($scope.showSection) {
          switch ($scope.showSection) {
            case 'setup':
              $scope.helpCaption = 'HelpNetworkPropertiesSetup';
              break;
            case 'computers':
              $scope.helpCaption = 'HelpNetworkPropertiesComputer';
              break;
          }
        }
      }, true);

      $scope.deleteGateway = function (gateway) {
        if (gateway) {
          $ngBootbox.confirm($filter('translate')('DeleteGateway')).then(function () {
            $scope.networkOriginal.removeGateway(gateway).then(function () {
              toastr.success($filter('translate')('GatewayDeleted'));
            }).catch(function () {
            });
          }).catch(function () {
          });
        } else {
          throw '$scope.deleteGateway: gateway is missing';
        }
      };

      $scope.saveChanges = function (form, $event) {
        if (form && $event) {
          if (form.$invalid) {
            $event.preventDefault();
          } else {
            $scope.waitingForAnswer = true;
            $scope.network.info.gateways = $scope.networkOriginal.info.gateways;
            $scope.network.info.version = $scope.networkOriginal.info.version;
            // remove!!!
            if ($scope.networkOriginal.info.gwMacs) {
              $scope.network.info.gwMacs = $scope.networkOriginal.info.gwMacs;
            }
            $scope.networkOriginal.saveChanges($scope.network).then(function (response) {
              $scope.waitingForAnswer = false;
              form.$setPristine();
              let message = '';
              if (response && response.data) {
                message = $filter('translate')('ChangesSaved');
              } else {
                message = $filter('translate')('NoChangesMade');
              }
              $location.path(URLS.NETWORK_LIST);
              toastr.success(message);
            }).catch(function () {
              $scope.waitingForAnswer = false;
            });
          }
        } else {
          throw '$scope.saveChanges: form or $event are missing';
        }
      };

      // Computers

      $scope.$watch(function () {
        return $scope.networkOriginal;
      }, function ()  {
        if ($scope.networkOriginal) {
          $scope.workstationListPaging.pagingCriteria.networks = [$scope.networkOriginal.info._links.self.href];
          $scope.getWorkstationListPaged();
        }
      }, true);

      $scope.getWorkstationListPaged = function () {
        if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
          WorkstationListService.getWorkstationListPaged($scope.workstationListPaging).then(function (workstationContainer) {
            $scope.workstationContainer = workstationContainer;
          }).catch(function () {
          });
        } else {
          const watch = $scope.$watch(function () {
            return TenantListService.currentTenant;
          }, function () {
            if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
              watch();
              $scope.getWorkstationListPaged();
            }
          }, true);
        }
      };

      $scope.getNextPage = function functionName(showPrevious) {
        if (showPrevious) {
          if ($scope.workstationListPaging.pagingCriteria.page > 0) {
            $scope.workstationListPaging.pagingCriteria.page--;
          }
        } else {
          if ($scope.workstationListPaging.pagingCriteria.page + 1 < $scope.workstationContainer.page.totalPages) {
            $scope.workstationListPaging.pagingCriteria.page++;
          }
        }
        $scope.getWorkstationListPaged();
      };

      $scope.changeOrderByValue = function (textValue) {
        $scope.reverseWorkstations = !$scope.reverseWorkstations;
        if ($scope.reverseWorkstations) {
          $scope.workstationListPaging.pagingCriteria.direction = 'DESC';
        } else {
          $scope.workstationListPaging.pagingCriteria.direction = 'ASC';
        }
        $scope.workstationListPaging.pagingCriteria.sort = textValue;
        $scope.orderWorkstationsByText = SORT_WORKSTATIONS[textValue];
        $scope.getWorkstationListPaged();
      };

      $scope.editWorkstation = function (workstation) {
        if (workstation) {
          const url = URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id);
          $location.path(url).search(URL_PARAMS.SHOW_WORKSTATION_SECTION.ROUTE, 'setup'); ;
        } else {
          throw '$scope.editSelectedUsers: workstation is missing';
        }
      };

      function getNetwork() {
        if ($routeParams[URL_PARAMS.NETWORK_ID.ROUTE]) {
          NetworkListService.getNetworkById($routeParams[URL_PARAMS.NETWORK_ID.ROUTE])
            .then(function (network) {
              if (network) {
                $scope.networkOriginal = network;
                $scope.network = angular.copy(network);
                $scope.isThisResourceMine = isThisResourceMine(network);
                getSite();
                $rootScope.secondaryHeadline = $scope.network.info.name;
              } else {
                $location.path(URLS.NETWORK_LIST);
              }
            })
            .catch(function () {
            });
        } else {
          $location.path(URLS.NETWORK_LIST);
        }
      }

      function getSite() {
        if ($scope.network.info._links['px:site']) {
          const url = $scope.network.info._links['px:site'].href;
          if (url) {
            SitesProviderService.getSite(url).then(function (site) {
              $scope.site = site;
            }).catch(function () {
            });
          }
        }
      }

      $scope.gotoSite = function (site) {
        const route = URLS.SITES.replace(':siteIds?', site.id);
        $location.path(route);
      };

      function isThisResourceMine(network) {
        const siteUrl = network?.info._links['px:site']?.href;
        return !!$scope.me?.isThisSiteMine(siteUrl);
      }

      ////////////////////////////////////
      ////////////////////////////////////
      //////  Open context menu
      ////////////////////////////////////
      $scope.openContext = function (event, context, menuOption) {
        $scope.closeAllMenues();
        $timeout(function  () {
          $scope.selectedContextMenuItem  =  menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          // $scope.contextContent = context;
          $scope.context = context;
          $scope.auxiliaries = {
            tenant: currentTenant,
            me: $scope.me
          };
        }, 50);
      };

      $scope.closeAllMenues = function () {
        $scope.menuContent = null;
        $scope.menuSpecs = null;
        $scope.selectedContextMenuItem = null;
        $scope.contextContentPosition = null;
        $scope.contextPosition = null;
        $scope.contextContent = null;
        $scope.context = null;
        $scope.auxiliaries = null;
      };

      function setListeners() {
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_CHANGED, function (name, data) {
          if (data.network === $scope.network.info._links.self.href) {
            getNetwork();
          }
        });
      }

    });
})();
